import React from 'react';
import { Cell } from 'react-table';
import cx from 'classnames';

import { IconTimeSchedule, IconWarningSign } from '@trqk/components';
import { formatNumberCompact } from '@trqk/utils';

import { SendColumn } from '../../../../../types';

interface IncludedAudioFilesCellProps {
    cell: Cell<TrqkGapChannel, GapChannelIncludedAudioFilesCellValue>;
    column: SendColumn<TrqkGapChannel>;
}

export const IncludedAudioFilesCell = ({
    cell,
    column,
}: IncludedAudioFilesCellProps): JSX.Element => {
    const {
        value: {
            channelStatus,
            channelId,
            channelNameDetection,
            channelNameStatement,
            stats: { included, total },
        },
    } = cell;
    const { send } = column;
    const includedFormatted = formatNumberCompact(included);
    const totalFormatted = formatNumberCompact(total);
    const disabled = channelNameStatement === null;
    const hasAnalysisError =
        channelStatus !== null && !['RAW', 'ANALYZED'].includes(channelStatus);

    return (
        <button
            type="button"
            className={cx('underline flex items-center text-primary-500', {
                'text-tertiary-400 cursor-default': disabled,
            })}
            disabled={disabled}
            onClick={() => {
                send({
                    type: 'START_CONFIRMING_WORKS',
                    value: {
                        channelName: channelNameDetection,
                        currentChannelId: channelId,
                    },
                });
            }}
        >
            {includedFormatted} of {totalFormatted}
            {channelStatus === 'RAW' && (
                <IconTimeSchedule
                    addClasses="ml-1"
                    width={16}
                    fillColor={disabled ? 'tertiary-400' : 'primary-500'}
                />
            )}
            {hasAnalysisError && (
                <IconWarningSign
                    addClasses="ml-1"
                    width={16}
                    fillColor="tertiary-400"
                />
            )}
        </button>
    );
};
